import type { FunctionComponent } from 'react';

export const Null: FunctionComponent = () => null;
